import { decodeBase64 } from '../utils/xmlParser';

/**
 * File loader service - handles loading files from GitHub, GitLab, or local source
 */
class FileLoaderService {
  constructor(githubClient, gitlabClient = null) {
    this.githubClient = githubClient;
    this.gitlabClient = gitlabClient;
  }

  async loadFromGithub(nameAndRepo, filePath, branch) {
    const base64Content = await this.githubClient.getFileContent(nameAndRepo, filePath, branch);
    return decodeBase64(base64Content);
  }

  async loadFromGitlab(nameAndRepo, filePath, branch) {
    const base64Content = await this.gitlabClient.getFileContent(nameAndRepo, filePath, branch);
    return decodeBase64(base64Content);
  }

  async loadFromLocal(fileRef) {
    return await fileRef.text();
  }
}

export default FileLoaderService;
